import { memo, useContext } from 'react';
import { AiOutlineMessage } from 'react-icons/ai';
import { FiUserCheck } from 'react-icons/fi';
import { unFollow } from '../../../../apis/follow.api';
import { postIncommingChat } from '../../../../apis/incomming.api';
import { handleToastIncommingModal } from '../../../../common/incommingModal';
import { IAlreadyFollow } from '../../../../interfaces/components/profileElement.interface';
import { RoleViewEnum } from '../../../../interfaces/profile.interface';
import AuthContext from '../../../../state/auth/AuthContext';
import { useModal } from '../../../../state/modal-provider/ModalProvider';

const AlreadyFollow: React.FC<IAlreadyFollow> = ({
  roleView,
  isAccepted,
  uid,
  refectAfterChangeInformation,
}) => {
  const { toast } = useModal();
  const { setLoading } = useContext(AuthContext);
  const handlePostIncommingChat = async () => {
    setLoading(true);
    try {
      await postIncommingChat();
      toast.success({ content: 'Xin cảm ơn ý kiến của bạn!' });
    } catch (error) {
      toast.error({ content: 'Có lỗi xảy ra.' });
    }
    setLoading(false);
  };
  const handleUnfollow = async () => {
    await unFollow(uid as string);
    await refectAfterChangeInformation();
  };
  return (
    <>
      {roleView === RoleViewEnum.Follow && isAccepted && (
        <div className="flex justify-center my-10 sm:my-2">
          <button
            className="w-36 border border-primary text-[14px] p-1.5 text-primary mx-2 rounded flex justify-center"
            onClick={() => {
              toast.action({
                title: 'Bỏ theo dõi',
                content: 'Bạn chắc chắn muốn bỏ theo dõi người này?',
                onAction: handleUnfollow,
                actionName: 'Có',
                closeAfterAction: true,
              });
            }}
          >
            <FiUserCheck className="text-[20px] mr-2" />
            Đang theo dõi
          </button>
          <button
            onClick={() =>
              handleToastIncommingModal({
                toast,
                cta_1_action: handlePostIncommingChat,
              })
            }
            className="w-36 border border-primary text-[14px] p-1.5 text-primary mx-2 rounded flex justify-center"
          >
            <AiOutlineMessage className="text-[20px] mr-2" />
            Nhắn tin
          </button>
        </div>
      )}
    </>
  );
};

export default memo(AlreadyFollow);
